// Don't export this from index because components that are rendered by react-router may
// also import below. This would result in "cannot access unintialized variable" error

import { CRMAudienceRoutes } from './getCrmRoutes/getCrmAudienceRoutes';
import { CRMBedboardRoutes } from './getCrmRoutes/getCrmBedboardRoutes';
import { CRMCampaignRoutes } from './getCrmRoutes/getCrmCampaignRoutes';
import { CRMOutboundCenterRoutes } from './getCrmRoutes/getCrmOutboundCenterRoutes';
import { CRMProspectRoutes } from './getCrmRoutes/getCrmProspectRoutes';
import { CRMReferralSourceRoutes } from './getCrmRoutes/getCrmReferralSourcesRoutes';
import { CRMScreenerResidentsRoutes } from './getCrmRoutes/getCrmScreenerResidentsRoutes';
import { CRMScreenerRoutes } from './getCrmRoutes/getCrmScreenerRoutes';
import { CRMSourcesRoutes } from './getCrmRoutes/getCrmSourcesRoutes';
import { CRMWaitlistRoutes } from './getCrmRoutes/getCrmWaitlistRoutes';
import { AddStaffRoutes } from './getSharedRoutes/getAddStaffRoutes';
import { AdminHubGeneralRoutes } from './getSharedRoutes/getAdminHubGeneralRoutes';
import { AdminHubProviderRoutes } from './getSharedRoutes/getAdminHubProviderRoutes';
import { AdminHubStaffOverviewRoutes } from './getSharedRoutes/getAdminHubStaffOverviewRoutes';
import { DataCenterRoutes } from './getSharedRoutes/getDataCenterRoutes';
import { AdminHubOrgWideSettingsRoutes } from './getSharedRoutes/getOrgWideSettingsRoutes';
import { StaffRoutes } from './getSharedRoutes/getStaffRoutes';

enum ErrorRoutes {
  Error = '/error',
  Unauthorized = '/unauthorized'
}

export enum TaskRoutes {
  TasksChronological = '/tasks/chronological',
  TasksByResident = '/tasks/by-resident'
}

enum ProfileRoutes {
  EHRProfile = '/profile',
  EHRProfileShifts = '/profile/shifts',
  Profile = '/crm/profile',
  ProfileShifts = '/crm/profile/shifts'
}

enum SecretRoutes {
  SecretFeatureFlagService = '/secret-feature-flag-service'
}

export const RoutePath = {
  ...ErrorRoutes,
  ...CRMScreenerResidentsRoutes,
  ...StaffRoutes,
  ...AddStaffRoutes,
  ...TaskRoutes,
  ...ProfileRoutes,
  ...AdminHubGeneralRoutes,
  ...AdminHubProviderRoutes,
  ...AdminHubStaffOverviewRoutes,
  ...DataCenterRoutes,
  ...CRMProspectRoutes,
  ...CRMOutboundCenterRoutes,
  ...CRMCampaignRoutes,
  ...CRMAudienceRoutes,
  ...CRMReferralSourceRoutes,
  ...CRMSourcesRoutes,
  ...CRMScreenerRoutes,
  ...CRMWaitlistRoutes,
  ...CRMBedboardRoutes,
  ...SecretRoutes,
  ...AdminHubOrgWideSettingsRoutes
} as const;

export type RoutePath = (typeof RoutePath)[keyof typeof RoutePath];
